import { render } from "./AddWorkSheetsPage.vue?vue&type=template&id=5238ea65"
import script from "./AddWorkSheetsPage.vue?vue&type=script&lang=js"
export * from "./AddWorkSheetsPage.vue?vue&type=script&lang=js"

import "./AddWorkSheetsPage.vue?vue&type=style&index=0&id=5238ea65&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__